import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Input, Button, Table, Segmented } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import TaskDetailModal from "../../components/task/taskDetailModal";
import "./TaskAppealPage.css";

const TaskAppealPage = () => {
  //获取数据
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detailData, setDetailData] = useState(null);
  const [detailloading, setDetailLoading] = useState(false);
  // 仲裁状态筛选：null 全部，0 待处理（未仲裁），1 已处理（已判决）
  const [status, setStatus] = useState(null);

  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const toLogin = () => {
    navigate("/login");
  };
  const openDetailModal = (taskId) => {
    setTitle("任务详情");
    setIsModalOpen(true);
    getDetailData(taskId);
  };
  const openAppealModal = (taskId, role) => {
    role === "2" ? setTitle("发布者申诉详情") : setTitle("接单者申诉详情");
    setIsModalOpen(true);
    getAppealData(taskId, role);
  };
  const openArbitrateModal = (taskId) => {
    setTitle("仲裁");
    setDetailData({ taskId });
    setIsModalOpen(true);
  };
  const getDetailData = async (taskId) => {
    setDetailLoading(true);
    try {
      const res = await axios.get(
        "/api/taskAppeal/findTaskInfoById/" + taskId,
        {
          headers: { "X-Access-Token": token },
        }
      );
      if (res.data.code == 401) {
        localStorage.clear();
        toLogin();
        return;
      }
      setDetailData(res.data.data || {});
    } catch (error) {
      console.error("数据获取失败:", error);
    } finally {
      setDetailLoading(false);
    }
  };
  const getAppealData = async (taskId, role) => {
    setDetailLoading(true);
    try {
      const res = await axios.post(
        "/api/taskAppeal/findTaskAppealByTaskIdAndRole",
        { taskId, role },
        {
          headers: { "X-Access-Token": token },
        }
      );
      if (res.data.code == 401) {
        localStorage.clear();
        toLogin();
        return;
      }
      setDetailData(res.data.data || []);
    } catch (error) {
      console.error("数据获取失败:", error);
    } finally {
      setDetailLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          "/api/taskAppeal/findTaskAppealList",
          status === null ? {} : { arbitrated: status },
          { headers: { "X-Access-Token": token } }
        );
        if (res.data.code == 401) {
          localStorage.clear();
          toLogin();
          return;
        }
        setData(res.data.data?.rows || []);
      } catch (error) {
        console.error("数据获取失败:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [status]);

  const columns = [
    {
      title: "任务标题",
      dataIndex: "title",
    },
    {
      title: "任务详情",
      dataIndex: "detail",
      render: (_, { taskId }) => (
        <a type="primary" onClick={() => openDetailModal(taskId)}>
          任务详情
        </a>
      ),
    },
    { title: "发布者ID", dataIndex: "publishUserNumber" },
    { title: "发布者手机号", dataIndex: "publishUserPhone" },
    {
      title: "发布者申诉详情",
      dataIndex: "publishCount",
      render: (_, { publishCount, taskId }) => {
        let content = "";
        if (publishCount) {
          content = (
            <a type="primary" onClick={() => openAppealModal(taskId, "2")}>
              {publishCount}条申诉
            </a>
          );
        } else {
          content = <span>0条申诉</span>;
        }
        return content;
      },
    },
    { title: "接单者ID", dataIndex: "completeUserNumber" },
    { title: "接单者手机号", dataIndex: "completeUserPhone" },
    {
      title: "接单者申诉详情",
      dataIndex: "completeCount",
      render: (_, { completeCount, taskId }) => {
        let content = "";
        if (completeCount) {
          content = (
            <a type="primary" onClick={() => openAppealModal(taskId, "1")}>
              {completeCount}条申诉
            </a>
          );
        } else {
          content = <span>0条申诉</span>;
        }
        return content;
      },
    },
    {
      title: "操作",
      dataIndex: "resultType",
      render: (_, { resultType, taskId }) => {
        let content = "";
        if (!resultType) {
          content = (
            <a type="primary" onClick={() => openArbitrateModal(taskId)}>
              仲裁
            </a>
          );
        } else {
          content = <span>已判决</span>;
        }
        return content;
      },
    },
    { title: "备注", dataIndex: "field2" },
  ];

  return (
    <div className="task-appeal-container">
      <div className="middlePart">
        <div className="status-card">
          <span>当前状态：</span>
          <Segmented
            value={status === null ? "all" : status}
            onChange={(value) =>
              setStatus(value === "all" ? null : Number(value))
            }
            options={[
              { label: "全部", value: "all" },
              { label: "待处理", value: 0 },
              { label: "已处理", value: 1 },
            ]}
          />
        </div>
        <div>
          <Input className="input" placeholder="任务单号、用户ID" />
          <Button type="primary" icon={<SearchOutlined />} iconPosition="start">
            Search
          </Button>
        </div>
      </div>
      <div className="table">
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey="taskId"
        />
      </div>
      <TaskDetailModal
        title={title}
        visible={isModalOpen}
        loading={detailloading}
        footer={[]}
        closeDialog={() => setIsModalOpen(false)}
        data={detailData}
      />
    </div>
  );
};

export default TaskAppealPage;
